import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { AlertSummary } from 'api-client'

interface AlertStatusStore {
  alertStatus: AlertSummary | undefined
  setAlertStatus: (alertStatus: AlertSummary | undefined) => void
  hasAlertStatus: () => boolean
}

export const useAlertStatusStore = create<AlertStatusStore>()(
  persist(
    (set, get) => ({
      alertStatus: undefined,
      hasAlertStatus: () => get().alertStatus !== undefined,
      setAlertStatus: (alertStatus: AlertSummary | undefined) =>
        set((state) => {
          if (alertStatus) {
            return { alertStatus }
          }
          return {
            alertStatus: state.alertStatus,
          }
        }),
    }),
    {
      version: 1,
      name: 'alert-status',
    }
  )
)
